import React, { createContext, useContext, useEffect, useState } from 'react';
import { Tag } from 'antd';
import dayjs from 'dayjs';
import WebsiteReportService from 'services/website_report';

const service = new WebsiteReportService();
const WebsiteStatisticContext = createContext();

const WebsiteStatisticProvider = ({ children }) => {
  const [data, setData] = useState({});
  const [filter, setFilter] = useState({
    range: {
      start: dayjs().add(-7, 'd').toDate(),
      end: dayjs().toDate(),
    },
  });

  const loadData = async () => {
    let range = null;

    if (filter.range) {
      range = {
        start: filter.range.start,
        end: filter.range.end,
      };
    }

    const result = await service.dashboard({ range });
    setData(result || {});
  };

  useEffect(() => {
    loadData();
  }, [filter]);

  return <WebsiteStatisticContext.Provider value={{ data, filter, setFilter }}>{children}</WebsiteStatisticContext.Provider>;
};

const useWebsiteStattistic = () => {
  return useContext(WebsiteStatisticContext);
};

const useWebsiteStatisticScreen = () => {
  const { data, filter, setFilter } = useWebsiteStattistic();

  const setFilterValue = (name, value) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  };

  const onDateRangeFilterChange = (value) => {
    if (!value) {
      setFilterValue('range', null);
      return;
    }

    setFilterValue('range', {
      start: value[0].startOf('d').format(),
      end: value[1].endOf('d').format(),
    });
  };

  const renderCollectionType = (type) => {
    const labelByType = {
      manual: 'Theo sản phẩm',
      tag: 'Theo tag',
      category: 'Theo danh mục',
    };

    const colorByType = {
      manual: 'blue',
      tag: 'green',
      category: 'purple',
    };

    return <Tag color={colorByType[type] || 'default'}>{labelByType[type] || type}</Tag>;
  };

  return {
    data,
    filter,
    onDateRangeFilterChange,
    renderCollectionType,
  };
};

export { WebsiteStatisticProvider, useWebsiteStattistic, useWebsiteStatisticScreen };
